
import React, { useState } from 'react';
import { assets } from '../assets/assets';

const Navbar = ({ setToken }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className='container d-flex align-items-center justify-content-between '>
      <img src={assets.logo} alt="" />
      <button
        onClick={() => setToken('')}
        className='p-2'
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={{
          backgroundColor: isHover ? 'blue' : '#000',
          color: 'white',
          border: 'none',
          borderRadius: '5px'
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Navbar;
